<template>
  <div>
    <Modal
      v-model="openUserBehavior"
      :hidden="hidden"
      width="1200px"
      :footer-hide="true"
      :styles="dragStyles"
      :draggable="true"
    >
      <p
        slot="header"
        style="color:#19be6b;text-align: center"
      >
        <span>行为轨迹</span>
        <Button
          type="primary"
          style="position: absolute;right: 100px;top:10px;"
          @click="openAddBehaviorNameDialog"
        >
          新增行为名称
        </Button>
      </p>
      <table-area
        :table-loading="behaviorLoading"
        :columns="behaviorColumns"
        :data="behaviorData"
        :total="behaviorTotal"
        :page-num="behaviorPageNum"
        :page-size="behaviorPageSize"
        @search="searchBehavior"
      />
    </Modal>
    <Modal
      v-model="openAddBehaviorName"
      width="600px"
      :styles="dragStyles"
      :draggable="true"
      @on-visible-change="changeAddNameVisible"
    >
      <p
        slot="header"
        style="color:#19be6b;text-align: center"
      >
        <span>新增行为名称</span>
      </p>
      <Form :model="addBehavior">
        <FormItem label="行为类型：">
          <Input
            v-model="addBehavior.eventId"
            maxlength="200"
            placeholder="请输入"
            style="width: 300px;"
          />
        </FormItem>
        <FormItem label="行为名称：">
          <Input
            v-model="addBehavior.eventName"
            maxlength="200"
            placeholder="请输入"
            style="width: 300px;"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          type="text"
          @click="openAddBehaviorName=false"
        >
          取消
        </Button>
        <Button
          type="primary"
          @click="saveAddBehaviorName"
        >
          确定
        </Button>
      </div>
    </Modal>

    <SameIpDeviceModal
      ref="sameIpDeviceModal"
      @close="()=>changeHidden(false)"
    />
  </div>
</template>
<script>
import { addBehaviorName, getUserBehaviorList } from "@/api/userapi"
import SameIpDeviceModal from "@components/SameIpDeviceModal.vue"
import userBehaviorColumns from './assets/UserBehaviorColumns';

export default {
  name: 'Userbehavior',
  components: { SameIpDeviceModal },
  props: {

  },
  data () {
    return {
      behaviorColumns: userBehaviorColumns(this),
      openUserBehavior: false,
      behaviorData: [],
      behaviorPageNum: 1,
      behaviorPageSize: 10,
      behaviorTotal: 0,
      behaviorLoading: false,
      openAddBehaviorName: false,
      addBehavior: {},
      userId: '',
      dragStyles: {
        position: 'absolute',
        top: 0,
        left: 0
      },
      hidden: false
    }
  },
  methods: {
    openDialog (userId) {
      this.userId = userId
      this.behaviorPageNum = 1
      this.openUserBehavior = true
      this.behaviorTotal = 0
      this.behaviorData = []
      this.getUserBehaviorList()
    },
    searchBehavior (pageIndex, pageSize) {
      this.behaviorPageNum = pageIndex || 1
      this.behaviorPageSize = pageSize || 10
      this.getUserBehaviorList()
    },
    getUserBehaviorList () {
      this.behaviorLoading = true
      const _this = this
      const params = '?userId=' + this.userId + '&pageNum=' + this.behaviorPageNum + '&' + 'pageSize=' + this.behaviorPageSize
      this.$get(getUserBehaviorList + params).then(da => {
        _this.behaviorData = da.data.data.list || []
        _this.behaviorTotal = da.data.data.total
        _this.behaviorLoading = false
      }).catch(err => {
        _this.behaviorLoading = false
        _this.$message.error(err.message)
      })
    },
    openAddBehaviorNameDialog () {
      this.addBehavior = {}
      this.openAddBehaviorName = true
    },
    saveAddBehaviorName () {
      if (!this.addBehavior.eventId) {
        this.$message.error('请输入行为类型')
        return
      }
      if (!this.addBehavior.eventName) {
        this.$message.error('请输入行为名称')
        return
      }
      const _this = this
      const params = Object.assign({}, this.addBehavior)
      this.$post(addBehaviorName, params).then(da => {
        _this.$message.success('新增成功')
        _this.openAddBehaviorName = false
        _this.getUserBehaviorList()
      })
    },
    changeAddNameVisible (e) {
      this.openUserBehavior = !e
    },
    querySameIpDeviceMemberList (loginIp, deviceId) {
      this.$refs.sameIpDeviceModal.openDialog(loginIp, deviceId, this.userId)
      this.changeHidden(true)
    },
    changeHidden (hidden) {
      this.hidden = hidden
    }
  }
}
</script>
<style lang="less" scoped>

</style>
